import { Breadcrumbs } from '@mui/material'
import { Link } from 'react-router-dom'

import { Stack } from '@mui/system'
import { useAppSelector } from '~/app/hooks'
import { currentTheme } from '~/redux/features'
import styles from './EFBreadcrumbs.module.scss'
import classNames from 'classnames/bind'
import { useTranslation } from 'react-i18next'
import { ALL_NS } from '~/i18n/namespaces'
import { IBreadcrumbProps } from './EFBreadcrumbs.model'
import { HomeIcon } from '../EFIcons'
import { EFTypography } from '../EFTypography'
import { useMobileView } from '~/hooks/useMobileView'

const cx = classNames.bind(styles)

export function EFBreadcrumbs(props: IBreadcrumbProps) {
  const theme = useAppSelector(currentTheme)
  const isMobile = useMobileView()
  const { t } = useTranslation(ALL_NS)
  const { locations, children } = props
  return (
    <Stack className={cx('breadcrumb-container', theme)}>
      <Breadcrumbs
        maxItems={isMobile ? 3 : 5}
        aria-label='breadcrumb'
      >
        <Link
          className={cx('breadcrumb-item', theme)}
          to='/'
        >
          <HomeIcon />
          <EFTypography
            color='link'
            sx={{ ml: 1 }}
          >
            {t('PageTitle_Dashboard')}
          </EFTypography>
        </Link>
        {locations.map((location, index) => {
          if (location.path && index !== locations.length - 1) {
            return (
              <Link
                key={index}
                className={cx('breadcrumb-item', theme)}
                to={location.path}
              >
                <span>{location.label ?? ''}</span>
              </Link>
            )
          }
          return (
            <span
              key={index}
              className={cx('breadcrumb-item', theme)}
            >
              <span>{location.label ?? ''}</span>
            </span>
          )
        })}
      </Breadcrumbs>
      {!isMobile && <Stack className={cx('breadcrumb-toolbar')}>{children}</Stack>}
    </Stack>
  )
}
